(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var hero = document.querySelector('[data-hc3-hero]');
    if (!hero) return;

    var version = hero.getAttribute('data-help-center-version') || '3.3';
    var input = hero.querySelector('[data-help-search]');
    var clear = hero.querySelector('[data-help-search-clear]');
    var panel = hero.querySelector('[data-help-search-results]');
    var list = hero.querySelector('[data-help-search-list]');
    var empty = hero.querySelector('[data-help-search-empty]');
    var count = hero.querySelector('[data-help-search-count]');
    var status = hero.querySelector('[data-help-search-status]');
    var answers = Array.prototype.slice.call(document.querySelectorAll('[data-help-answer]'));
    var topicJump = document.querySelector('[data-help-topic-jump]');
    var topicPlaceholder = document.querySelector('[data-help-topic-jump-placeholder]');
    var topicSelect = document.querySelector('[data-help-topic-select]');
    var searchTimer = null;
    var lastTrackedQuery = '';
    var noResultTracked = '';
    var jumpStart = 0;
    var rafPending = false;
    var debug = new URLSearchParams(window.location.search).get('hc_debug') === '1';

    function pushEvent(name, params) {
      
      var payload = {
        event: name,
        help_center_version: version,
        page_path: window.location.pathname
      };
      Object.keys(params || {}).forEach(function (key) { payload[key] = params[key]; });
      window.CAEvidence.push(payload);
      if (debug && window.console) console.info('[Help Center event]', payload);
    }

    function normalise(value) {
      return (value || '')
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function answerData(answer) {
      var question = answer.querySelector('.cah3__faq-question');
      var category = answer.getAttribute('data-category-label') || '';
      var keywords = answer.getAttribute('data-keywords') || '';
      return {
        element: answer,
        id: answer.id,
        question: question ? question.textContent.trim() : '',
        category: category,
        haystack: normalise(answer.textContent + ' ' + keywords + ' ' + category)
      };
    }

    var index = answers.map(answerData);

    function cssNumber(name) {
      var value = window.getComputedStyle(document.documentElement).getPropertyValue(name);
      var parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function siteHeaderHeight() {
      var height = cssNumber('--header-height');
      var selectors = ['sticky-header', '.section-header', '.header-wrapper', 'header[role="banner"]', '#shopify-section-header'];
      selectors.forEach(function (selector) {
        var element = document.querySelector(selector);
        if (!element) return;
        var rect = element.getBoundingClientRect();
        var style = window.getComputedStyle(element);
        if ((style.position === 'fixed' || style.position === 'sticky') && rect.bottom > 0 && rect.top <= 2) {
          height = Math.max(height, rect.bottom);
        }
      });
      return Math.max(0, Math.round(height));
    }

    function topicJumpHeight() {
      if (!topicJump || !topicJump.classList.contains('is-fixed')) return 0;
      return Math.round(topicJump.getBoundingClientRect().height || 0);
    }

    function anchorOffset() {
      return siteHeaderHeight() + topicJumpHeight() + 22;
    }

    function updateRuntimeOffset() {
      var height = siteHeaderHeight();
      document.documentElement.style.setProperty('--hc-runtime-header-height', height + 'px');
      return height;
    }

    function scrollToTarget(target, focus) {
      if (!target) return;
      var top = window.pageYOffset + target.getBoundingClientRect().top - anchorOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      if (focus) {
        window.setTimeout(function () {
          var focusTarget = target.matches('details') ? target.querySelector('summary') : target;
          if (focusTarget && typeof focusTarget.focus === 'function') {
            if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('summary, a, button, input, select, textarea')) {
              focusTarget.setAttribute('tabindex', '-1');
            }
            focusTarget.focus({ preventScroll: true });
          }
        }, 450);
      }
    }

    function navigateToId(id, focus, replace) {
      var target = document.getElementById(id);
      if (!target) return false;
      if (target.hasAttribute('data-help-answer')) target.open = true;
      if (replace) history.replaceState(null, '', '#' + id);
      else history.pushState(null, '', '#' + id);
      window.setTimeout(function () { scrollToTarget(target, focus); }, 35);
      return true;
    }

    function renderResults(query) {
      var clean = normalise(query);
      var terms = clean ? clean.split(' ') : [];
      var matches = clean ? index.filter(function (item) {
        return terms.every(function (term) { return item.haystack.indexOf(term) !== -1; });
      }) : [];

      if (clear) clear.hidden = clean.length === 0;
      if (panel) panel.hidden = clean.length === 0;
      if (list) list.innerHTML = '';
      if (empty) empty.hidden = matches.length > 0 || clean.length === 0;
      if (count) count.textContent = matches.length ? matches.length + ' found' : '';
      if (status) status.textContent = clean ? (matches.length + ' matching answer' + (matches.length === 1 ? '' : 's')) : 'Search ' + index.length + ' answers or browse by topic below.';

      matches.slice(0, 8).forEach(function (item) {
        var link = document.createElement('a');
        link.className = 'cah3__search-result';
        link.href = '#' + item.id;
        link.setAttribute('data-search-result-id', item.id);
        var copy = document.createElement('span');
        var category = document.createElement('small');
        var question = document.createElement('strong');
        var arrow = document.createElement('span');
        category.textContent = item.category;
        question.textContent = item.question;
        arrow.textContent = '→';
        arrow.setAttribute('aria-hidden', 'true');
        copy.appendChild(category);
        copy.appendChild(question);
        link.appendChild(copy);
        link.appendChild(arrow);
        list.appendChild(link);
      });

      window.clearTimeout(searchTimer);
      if (clean.length >= 2) {
        searchTimer = window.setTimeout(function () {
          if (clean !== lastTrackedQuery) {
            pushEvent('help_search', { query_length: clean.length, result_count: matches.length });
            lastTrackedQuery = clean;
          }
          if (matches.length === 0 && clean !== noResultTracked) {
            pushEvent('help_search_no_result', { query_length: clean.length });
            noResultTracked = clean;
          }
        }, 500);
      }
    }

    function updateTopicJumpStart() {
      updateRuntimeOffset();

      if (!topicJump || !topicPlaceholder) return;

      topicJump.classList.remove('is-fixed');
      topicPlaceholder.classList.remove('is-active');
    }

    function updateFixedTopicJump() {
      updateRuntimeOffset();

      if (!topicJump || !topicPlaceholder) return;

      topicJump.classList.remove('is-fixed');
      topicPlaceholder.classList.remove('is-active');
    }

    function updateCurrentTopic() {
      if (!topicJump) return;
      var links = Array.prototype.slice.call(topicJump.querySelectorAll('a[href^="#"]'));
      var current = '';
      var threshold = anchorOffset() + 10;
      links.forEach(function (link) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target && target.getBoundingClientRect().top <= threshold) current = id;
      });
      links.forEach(function (link) {
        var isCurrent = link.getAttribute('href') === '#' + current;
        if (isCurrent) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (topicSelect && current) topicSelect.value = '#' + current;
    }

    function onScroll() {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(function () {
        updateFixedTopicJump();
        updateCurrentTopic();
        rafPending = false;
      });
    }

    if (input) input.addEventListener('input', function () { renderResults(input.value); });
    if (clear) clear.addEventListener('click', function () {
      input.value = '';
      renderResults('');
      input.focus();
    });

    if (topicSelect) topicSelect.addEventListener('change', function () {
      var value = topicSelect.value || '';
      if (!value || value.charAt(0) !== '#') return;
      var selected = topicSelect.options[topicSelect.selectedIndex];
      pushEvent('help_category_click', { category_id: selected.getAttribute('data-category-id') || '' });
      navigateToId(value.slice(1), true, false);
    });

    document.addEventListener('click', function (event) {
      var result = event.target.closest('[data-search-result-id]');
      if (result) {
        event.preventDefault();
        navigateToId(result.getAttribute('data-search-result-id'), true, false);
        return;
      }

      var popular = event.target.closest('[data-help-popular-link]');
      if (popular) {
        event.preventDefault();
        navigateToId('help-' + popular.getAttribute('data-question-id'), true, false);
        return;
      }

      var quick = event.target.closest('[data-help-quick-action]');
      if (quick) pushEvent('help_quick_action_click', { action_id: quick.getAttribute('data-action-id') || '' });

      var category = event.target.closest('[data-help-category-click]');
      if (category) pushEvent('help_category_click', { category_id: category.getAttribute('data-category-id') || '' });

      var policy = event.target.closest('[data-help-policy-click]');
      if (policy) {
        pushEvent('help_policy_click', {
          question_id: policy.getAttribute('data-question-id') || '',
          destination: policy.getAttribute('data-destination') || policy.getAttribute('href') || ''
        });
      }

      var guide = event.target.closest('[data-help-guide-click]');
      if (guide) pushEvent('help_guide_click', { guide_id: guide.getAttribute('data-guide-id') || '' });

      var contact = event.target.closest('[data-help-contact-click]');
      if (contact) {
        pushEvent('help_contact_click', {
          channel: contact.getAttribute('data-channel') || '',
          source_section: contact.getAttribute('data-source-section') || ''
        });
      }

      var internal = event.target.closest('.cah3 a[href^="#"]');
      if (internal) {
        var id = internal.getAttribute('href').slice(1);
        if (document.getElementById(id)) {
          event.preventDefault();
          navigateToId(id, false, false);
        }
      }
    });

    answers.forEach(function (answer) {
      answer.addEventListener('toggle', function () {
        if (answer.open) {
          pushEvent('help_faq_open', {
            category_id: answer.getAttribute('data-category-id') || '',
            question_id: answer.getAttribute('data-question-id') || ''
          });
        }
      });
    });

    function handleHash() {
      var id = window.location.hash ? window.location.hash.slice(1) : '';
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      if (target.hasAttribute('data-help-answer')) target.open = true;
      window.setTimeout(function () { scrollToTarget(target, false); }, 120);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      window.clearTimeout(window.__hc3ResizeTimer);
      window.__hc3ResizeTimer = window.setTimeout(updateTopicJumpStart, 140);
    });
    window.addEventListener('hashchange', handleHash);
    window.addEventListener('popstate', handleHash);

    updateTopicJumpStart();
    updateCurrentTopic();
    handleHash();

    window.CAHelpCenter = {
      version: version,
      getAnchorOffset: anchorOffset,
      pushEvent: pushEvent,
      debug: debug
    };
  });
})();
